export default "__VITE_ASSET__D4PpYQ4R__"